<template>
    <div>
        <div class="row"> <!--foto-->
          <h3 v-if="showHeader">Фото</h3>
          <div class="col-12">
            <div class="row">
              <img v-if="userFoto" :src="userFoto" style="display: none" ref="userFotoForSizeMeasure" @load="photoLoaded" />
              <img :src="userFoto || '/img/no-photo.png'" alt="если Вы видите эту надпись, скорее всего произошла ошибка при загрузке Вашего фото с сервера" class="img-thumbnail rounded foto" ref="userFoto" />
              <input
                type="file"
                style="display: none;"
                ref="foto"
                accept="image/jpeg, image/png, image/jpg"
                v-on:change="upLoad"
              />
            </div>
            <div class="row mt-1">
              <button type="button" class="btn btn-info btn-sm" @click="loadFoto">{{ userFoto ? 'Загрузить другое фото' : 'Загрузить' }}</button>
              <button type="button" :class="['btn btn-warning btn-sm ml-2', badPhotoProportion ? 'blinking' : null]" @click="editFoto" :disabled="!userFoto">Обрезать</button>
            </div>
            <p v-if="badPhotoProportion" class="text-danger"><br />Требуется изображение в пропорции 3:4</p>
          </div>
        </div>

        <FotoRedactor v-if="getShowFotoRedactor" @get-foto="getFoto"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FotoRedactor from '@/components/PhotoEditor.vue'

export default {
    props: {
        showHeader: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        ...mapGetters([ 'getShowFotoRedactor' ]),
        badPhotoProportion() {
          if (this.userFoto && this.photoWidth && this.photoHeight) {
            const prop = this.photoHeight / this.photoWidth;
            if (prop < 1.30 || prop > 1.36) {
              return true;
            }
          }

          return false;
        },
    },
    data() {
        return {
            userFoto: this.$store.getters.getUserData.memberInfo?.photo,
        }
    },
    methods: {
      loadFoto() { // обработка нажатия на кнопку загрузка фото
        this.$refs.foto.click()
      },
      photoLoaded() {
          this.updatePhotoSize();
      },
      updatePhotoSize() {
          const img = this.$refs.userFotoForSizeMeasure;
          if (img) {
              this.photoWidth = img.width;
              this.photoHeight = img.height;
          }
      },
      upLoad(event) { // Загрузка фото
        const input = event.target;

        if (input.files && input.files[0]) {
          //for (let i=0; i<input.files.length; i++) {
          let reader = new FileReader();

          reader.onload = (e) => {
            this.$refs.userFoto.src = e.target.result
            if (this.showMemberCard) this.$refs.userFotoCard.src = e.target.result
            this.userFoto = e.target.result
            //this.accept()
            this.submitFoto()
          }

          reader.readAsDataURL(input.files[0]);
          //}
        } else {
          this.userFoto = null;
          this.$refs.userFoto.src = this.userFoto
          if (this.showMemberCard) this.$refs.userFotoCard.src = this.userFoto
          //this.accept()
        }
      },
      getFoto(foto) {
        this.$refs.userFoto.src = foto
        if (this.showMemberCard) this.$refs.userFotoCard.src = foto
        this.userFoto = foto
        this.submitFoto()
      },
      isErrorImg() {
        if (!this.isImage()) {
          this.$store.commit('setDataToast', { state: 0, text: 'Необходимо загрузить фото' })
          return true
        }
        return false
      },
      isImage() {
        const name = this.$refs.foto.files[0]?.name
        if (!name && !this.$store.getters.getUserData.memberInfo?.photo) {
          return false
        } else if (name) {
          const arr = name.split('.')
          if (this.image.filter(item => item === arr[arr.length - 1]).length === 1) return true
          else return false
        }
        return true
      },
      submitFoto() {
        // сохранить фото на сервере
        let data = new FormData()
        data.append('photo', this.userFoto)
        this.$store.dispatch('savePhoto', data).then(() => { this.$emit('uploaded') })
      },
      editFoto() {
        if (this.isErrorImg()) return false

        this.$store.commit('setOldFoto', this.userFoto)
        this.$store.commit('setShowFotoRedactor', true)
      },
    },
    components: {
        FotoRedactor,
    }
}
</script>

<style scoped>
.foto {
  width: 150px;
  height: 200px;
  /* object-fit: cover; */
}

.blinking {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}

@keyframes blink-animation {
  0% {
    opacity: 0.1;
  }

  25% {
    opacity: 1;
  }

  75% {
    opacity: 1;
  }

  100% {
    opacity: 0.1;
  }
}
</style>
